import { ConfigurationType } from '../dependencies/types';

export enum ActiveState {
  activeOnly = 'activeOnly',
  activeAndInactive = 'activeAndInactive',
}

export const apexConfigurationTypes = [
  { label: 'Class', value: ConfigurationType.apexClasses },
  { label: 'Trigger', value: ConfigurationType.apexTriggers },
];

export const activeFilterOptions = [
  { label: 'Only active', value: ActiveState.activeOnly },
  { label: 'Active and inactive', value: ActiveState.activeAndInactive },
];
